module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-reports/summary-reports/summary-reports.component.css
// module id = ./src/app/hrms/payroll/payroll-reports/summary-reports/summary-reports.component.css
// module chunks = main